import { useState } from "react";
import FooterList from "./FooterList";
import FooterSocial from "./FooterSocial";
import './footer.css';
import FooterApp from "./FooterApp";
const Footer = () => {
    const list1 = [
        {
            title: "Home",
            href: "/",
        },
        {
            title: "About EventPlanet",
            href: "https://eventplanet.in/about-us",
        },
        {
            title: "Contact Us",
            href: "https://eventplanet.in/contact-us",
        },
        {
            title: "Terms & Conditions",
            href: "/terms-condition",
        },
        {
            title: "Privacy Policy",
            href: "/privacy-policy",
        },
        {
            title: "Blogs",
            href: "https://eventplanet.in/blog/",
        },
        {
            title: "Delete Account",
            href: "/delete-account",
        },
    ];
    const list2 = [
        {
            title: "Venue",
            href: "https://eventplanet.in/venue",
        },
        {
            title: "Vendors",
            href: "https://eventplanet.in/vendors",
        },
        {
            title: "Beauty & Outfits",
            href: "https://eventplanet.in/outfits",
        },
        {
            title: "Event Planner",
            href: "https://eventplanet.in/vendors?sub_cat_id=t5CjPhRmhZAgJ5ZxXKlQ&page=1&limit=40",
        },
        {
            title: "Corporate Events",
            href: "https://eventplanet.in/corporate-events?sub_cat_id=iAfD04pQNNJjvBLA4jeF&page=1&limit=40",
        },
        {
            title: "Event Shopping",
            href: "https://eventplanet.in/event-shopping",
        },
        {
            title: "Birthday",
            href: "https://eventplanet.in/birthday",
        }
    ];
    const list3 = [
        {
            title: "Transportation",
            href: "https://eventplanet.in/transportation",
        },
        {
            title: "Decorator",
            href: "https://eventplanet.in/vendors?sub_cat_id=cL3ML2kGQq73UwopisjS&page=1&limit=40",
        },

        {
            title: "Photography",
            href: "https://eventplanet.in/vendors?sub_cat_id=zqq7qmE7wtG838LDX8hJ&page=1&limit=40",
        },
        {
            title: "Catering",
            href: "https://eventplanet.in/vendors?sub_cat_id=zqq7qmE7wtG838LDX8hJ&page=1&limit=40",
        },
        {
            title: "Makeup Artist",
            href: "https://eventplanet.in/outfits?sub_cat_id=REgfHYF9tUNeip9MoIiJ&page=1&limit=40",
        },
    ];
    return (
        <>
            <section className="footer" style={{ borderTop: '1px solid #ccc' }}>
                <div className="container">
                    <div className="row mt-3">
                        <FooterList list={list1} />
                        <FooterList list={list2} />
                        <FooterApp/>
                        <FooterSocial />
                    </div>
                </div>
            </section>
            <div className="fo_border">
                <a href="https://eventplanet.in" style={{ textDecoration: 'none', color: '#fff' }}>&copy;&nbsp;2026  Reserved by Event Planet Technologies India Pvt Ltd || All Rights Reserved</a>
            </div>
        </>

    );
};

export default Footer;